import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';

import { getSupplierActivationRequestsQueryOptions } from '~/data/supplier/useQuerySupplierActivationRequests';
import { getSupplierDetailQueryOptions } from '~/data/supplier/useQuerySupplierDetail';
import { getSupplierHistoryQueryOptions } from '~/data/supplier/useQuerySupplierHistory';

import { SupplierDetails } from '~/modules/suppliers/single';

import { i18n } from '~/utils';
import { buildRouteExport } from '~/utils/buildRouteExport';
import { createProtectedRoute } from '~/utils/routeProtection';
import { getRouteHead } from '~/utils/routeUtils';

import { routeParams } from './-routeParams';

const title = i18n.t(($) => $.details.pageTitle, { ns: 'suppliers' });

const zodSupplierDetailSearchSchema = z.object({
  requestActivation: z.uuid().optional().catch(undefined),
});

export const Route = createFileRoute('/(main)/suppliers/$supplierId/')({
  beforeLoad: createProtectedRoute({
    routePath: '/suppliers/$supplierId',
    ...routeParams,
  }),
  component: SupplierDetails,
  head: () => getRouteHead(title),
  loader: async ({ context: { queryClient }, params: { supplierId } }) => {
    void queryClient.prefetchQuery(
      getSupplierHistoryQueryOptions({ deId: supplierId }),
    );

    void queryClient.prefetchQuery(
      getSupplierActivationRequestsQueryOptions({ deId: supplierId }),
    );

    await queryClient.ensureQueryData(
      getSupplierDetailQueryOptions({ deId: supplierId }),
    );
  },
  staticData: {
    AppBar: {
      title,
    },
  },
  validateSearch: zodSupplierDetailSearchSchema,
});

export const SUPPLIER_DETAIL = buildRouteExport({ Route, ...routeParams });
